import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioToggleWithLabel = _resolveComponent("StudioToggleWithLabel")!
  const _component_ModuleWrapper = _resolveComponent("ModuleWrapper")!

  return (_openBlock(), _createBlock(_component_ModuleWrapper, {
    moduleId: _ctx.moduleId,
    title: "Enter Event Experience",
    onInitializeData: _ctx.initializeData
  }, {
    main: _withCtx(() => [
      _createVNode(_component_StudioToggleWithLabel, {
        id: "enter-event-button-toggle",
        label: "Enter Event Button",
        subLabel: "This setting cannot be changed less than one hour before the start of the event. Hide the button that allows users to enter the event from the event landing page. 60 minutes before the event starts the button will automatically be enabled and allow attendees to enter.",
        class: "tw-mb-7",
        checked: _ctx.enterEventButtonEnabled,
        title: 
          _ctx.isEnterEventButtonToggleDisabled
            ? 'This setting cannot be changed less than one hour before the start of the event'
            : ''
        ,
        disabled: _ctx.isEnterEventButtonToggleDisabled,
        "onUpdate:checked": _ctx.handleEnterEventButtonToggle
      }, null, 8, ["checked", "title", "disabled", "onUpdate:checked"]),
      _createVNode(_component_StudioToggleWithLabel, {
        id: "attendee-tech-check-toggle",
        label: "Attendee Tech Check",
        subLabel: "Require attendees to test their network strength and audio before entering the event.",
        class: "tw-mb-7",
        checked: _ctx.attendeeTechCheckEnabled,
        "onUpdate:checked": _ctx.handleAttendeeTechCheckToggle
      }, null, 8, ["checked", "onUpdate:checked"]),
      _createVNode(_component_StudioToggleWithLabel, {
        id: "show-onboarding-toggle",
        label: "Mandatory Attendee Profiles",
        subLabel: "Require attendees to create a profile when entering the event for the first time.",
        checked: _ctx.showOnboarding,
        "onUpdate:checked": _ctx.handleShowOnboardingToggle
      }, null, 8, ["checked", "onUpdate:checked"])
    ]),
    _: 1
  }, 8, ["moduleId", "onInitializeData"]))
}